import { render } from "./ChapterRefsWidget.vue?vue&type=template&id=04fb328a&scoped=true"
import script from "./ChapterRefsWidget.vue?vue&type=script&lang=js"
export * from "./ChapterRefsWidget.vue?vue&type=script&lang=js"

import "./ChapterRefsWidget.vue?vue&type=style&index=0&id=04fb328a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fb328a"]])

export default __exports__